import React, { Component } from "react";
import "w3-css/3/w3.css";

class FromCelsiusButton extends Component {
  handleClickButon = buttonId => {
    this.props.celTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Celsius to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <DelisleButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FahrenheitButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KelvinButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <NewtonButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RankineButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <ReaumurButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RomerButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromFahrenheitButton extends Component {
  handleClickButon = buttonId => {
    this.props.fahTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Fahrenheit to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CelsiusButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <DelisleButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <NewtonButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KelvinButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RankineButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <ReaumurButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RomerButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromKelvinButton extends Component {
  handleClickButon = buttonId => {
    this.props.kelTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Kelvin to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CelsiusButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <DelisleButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FahrenheitButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <NewtonButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RankineButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <ReaumurButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RomerButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromRankineButton extends Component {
  handleClickButon = buttonId => {
    this.props.ranTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Rankine to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CelsiusButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <DelisleButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FahrenheitButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KelvinButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <NewtonButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <ReaumurButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RomerButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromDelisleButton extends Component {
  handleClickButon = buttonId => {
    this.props.delTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Delisle to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CelsiusButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FahrenheitButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KelvinButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <NewtonButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RankineButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <ReaumurButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RomerButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromNewtonButton extends Component {
  handleClickButon = buttonId => {
    this.props.newTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Newton to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CelsiusButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <DelisleButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FahrenheitButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KelvinButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RankineButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <ReaumurButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RomerButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromReaumurButton extends Component {
  handleClickButon = buttonId => {
    this.props.reaTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From R&eacute;aumur to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CelsiusButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <DelisleButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FahrenheitButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KelvinButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <NewtonButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RankineButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RomerButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromRomerButton extends Component {
  handleClickButon = buttonId => {
    this.props.romTemp(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From R&oslash;mer to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CelsiusButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <DelisleButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FahrenheitButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KelvinButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <NewtonButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <RankineButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <ReaumurButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class CelsiusButton extends Component {
  handleUpButton = () => {
    let name = "cel";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="celsius"
        >
          Celsius
        </button>
      </span>
    );
  }
}

class FahrenheitButton extends Component {
  handleUpButton = () => {
    let name = "fah";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="fahrenheit"
        >
          Fahrenheit
        </button>
      </span>
    );
  }
}

class KelvinButton extends Component {
  handleUpButton = () => {
    let name = "kel";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="kelvin"
        >
          Kelvin
        </button>
      </span>
    );
  }
}

class RankineButton extends Component {
  handleUpButton = () => {
    let name = "ran";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="rankine"
        >
          Rankine
        </button>
      </span>
    );
  }
}

class DelisleButton extends Component {
  handleUpButton = () => {
    let name = "del";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="delisle"
        >
          Delisle
        </button>
      </span>
    );
  }
}

class NewtonButton extends Component {
  handleUpButton = () => {
    let name = "new";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="newton"
        >
          Newton
        </button>
      </span>
    );
  }
}

class ReaumurButton extends Component {
  handleUpButton = () => {
    let name = "rea";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="reamur"
        >
          R&eacute;aumur
        </button>
      </span>
    );
  }
}

class RomerButton extends Component {
  handleUpButton = () => {
    let name = "rom";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="romer"
        >
          R&oslash;mer
        </button>
      </span>
    );
  }
}

export {
  FromCelsiusButton,
  FromFahrenheitButton,
  FromKelvinButton,
  FromRankineButton,
  FromDelisleButton,
  FromNewtonButton,
  FromReaumurButton,
  FromRomerButton
};
